<template>
    <div class="content md">
        <system-admin type="light"></system-admin>
    </div>
</template>

<script>
    import SystemAdmin from "../../layouts/SystemAdmin";
    export default {
        name: "LightAdmin",
        components: {
            SystemAdmin
        }
    }
</script>

<style scoped>

</style>
